export const ActiveLoansColumns = [
    {
        Header: "SL No",
        accessor: "slNo",
    },
    {
        Header: "Loan Money",
        accessor: "loanMoney",
    },
    {
        Header: "Left To Repay",
        accessor: "leftToRepay",
    },
    {
        Header: "Duration",
        accessor: "duration",
    },
    {
        Header: "Interest Rate",
        accessor: "interestRate",
    },
    {
        Header: "Installment",
        accessor: "installment",
    },
    {
        Header: "Repay",
        accessor: "repay",
    },
]

export const ActiveLoansTableData = [
    {
        slNo: "01",
        loanMoney: "$150000",
        leftToRepay: "$40500",
        duration: "	8 Months",
        interestRate: "14%",
        installment: "$2,000 / month",
    },
    {
        slNo: "02",
        loanMoney: "$500000",
        leftToRepay: "$70500",
        duration: "16 Months",
        interestRate: "12%",
        installment: "$2,500 / month",
    },
    {
        slNo: "03",
        loanMoney: "$600000",
        leftToRepay: "$205900",
        duration: "14 Months",
        interestRate: "11%",
        installment: "$1,000 / month",
    },
    {
        slNo: "04",
        loanMoney: "$160000",
        leftToRepay: "$30560",
        duration: "17 Months",
        interestRate: "12%",
        installment: "$8,000 / month",
    },
    {
        slNo: "05",
        loanMoney: "$190000",
        leftToRepay: "$46500",
        duration: "	16 Months",
        interestRate: "18%",
        installment: "$2,000 / month",
    },
    {
        slNo: "06",
        loanMoney: "$900000",
        leftToRepay: "$90500",
        duration: "45 Months",
        interestRate: "9%",
        installment: "$2,600 / month",
    },
    {
        slNo: "07",
        loanMoney: "$400000",
        leftToRepay: "$60900",
        duration: "21 Months",
        interestRate: "14%",
        installment: "$2,200 / month",
    },
    {
        slNo: "08",
        loanMoney: "$500000",
        leftToRepay: "$80500",
        duration: "22Months",
        interestRate: "19%",
        installment: "$2,200 / month",
    },
    {
        slNo: "09",
        loanMoney: "$500000",
        leftToRepay: "$10500",
        duration: "13 Months",
        interestRate: "6%",
        installment: "$2,200 / month",
    },
    {
        slNo: "10",
        loanMoney: "$500000",
        leftToRepay: "$40000",
        duration: "17 Months",
        interestRate: "10%",
        installment: "$2,300 / month",
    },
    {
        slNo: "11",
        loanMoney: "$500000",
        leftToRepay: "$20500",
        duration: "11 Months",
        interestRate: "13%",
        installment: "$2,000 / month",
    },
    {
        slNo: "12",
        loanMoney: "$140000",
        leftToRepay: "$40500",
        duration: "13 Months",
        interestRate: "12%",
        installment: "$3,000 / month",
    },
]